var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-header',{staticClass:"csn-secondary-header"},[_c('cs-secondary-header',{staticClass:"csn-secondary-header__header",attrs:{"title":_vm.title,"align-title":"center"},on:{"back":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }